export const grid = {
  methods: {
    getSortBy: function(context, id, defaultSort) {
      var sortBy = context.$cookie.get(id);

      return sortBy == null ? defaultSort : sortBy;
    },
    setSortBy: function(context, id, sortBy) {
      context.$cookie.set(id, sortBy, { expires: '1Y' });
    },
    getSortDesc: function(context, id, defaultSortDesc) {
      var sortDesc = context.$cookie.get(id);

      return sortDesc == null ? defaultSortDesc : sortDesc === 'true';
    },
    setSortDesc: function(context, id, sortDesc) {
      context.$cookie.set(id, sortDesc, { expires: '1Y' });
    },
    getFilter: function(context, id) {
      var filter = context.$cookie.get(id);

      if (filter == null) {
        return {
          filterString: '',
          items: []
        };
      }

      return JSON.parse(filter);
    },
    setFilter: function(context, id, filter) {
      context.$cookie.set(id, filter, { expires: '1Y' });
    },
    getCurrentPage: function(context, id, defaultCurrentPage) {
      var currentPage = context.$cookie.get(id);

      return currentPage == null ? defaultCurrentPage : parseInt(currentPage);
    },
    setCurrentPage: function(context, id, page) {
      context.$cookie.set(id, page, { expires: '1Y' });
    },
    getPerPage: function(context, id, rowsOnPage) {
      var perPage = context.$cookie.get(id);

      var value = perPage == null ? rowsOnPage : parseInt(perPage);

      var rowsPerPage = this.getRowsPerPageOptions(rowsOnPage);
      var perPageOccurs = false;

      rowsPerPage.forEach(p => {
        if (p === value) {
          perPageOccurs = true;
        }
      });

      if (!perPageOccurs) {
        value = rowsOnPage;
      }

      return value;
    },
    setPerPage: function(context, id, page) {
      context.$cookie.set(id, page, { expires: '1Y' });
    },
    getRowsPerPageOptions: function(rowsOnPage) {
      var options = [10, 25, 50, 100];

      if (rowsOnPage !== null) {
        options.push(rowsOnPage);
      }

      return options.sort(function(a, b) {
        return a - b;
      });
    }
  }
};
